import React, { useEffect, useRef, useState } from 'react'

const useToggleDropdown = () => {
    const [isDropdownOpen, setIsDropDownOpen] = useState(false);

    const dropdownRef = useRef(null);

    const toggleDropdown = () => {
        setIsDropDownOpen((prevState) => !prevState);
    }

    const handleClickOutside = (event) => {
        // Close dropdown if click is outside the dropdown element
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsDropDownOpen(false);
        }
    };

    useEffect(() => {
        // Attach the event listener when the dropdown is open
        if (isDropdownOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        // Clean up listener on component unmount or dropdown close
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isDropdownOpen]);
    return { isDropdownOpen, setIsDropDownOpen, toggleDropdown,dropdownRef }
}

export default useToggleDropdown